module.exports = "/images/speedometer.svg?c8680bcf087eef0c3ea6ec2906e40bc8";